import "./styles/keyframes.css";
import React from "react";
import Loader from "./Loader";
import Whitespace from "../Whitespace";
import LoadingText from "./LoadingText";



const LoaderWithText = () => {

  return (
      <>
        <Loader />
        <Whitespace x="1" />
        <LoadingText />
      </>
  );
};

export default LoaderWithText;